import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceConfig } from './service.url.config';
import { Logger } from '../log/logger';
// import { LocalStorageService } from 'angular-web-storage';
import { LocalStorageService } from '../../shared/local-storage.service'

@Injectable({
  providedIn: 'root'
})

export class ServiceProvider {
  localUrl = 'assets/data/smartphone.json';
  serviceUrl: any;
  serviceTypeList: any;
  constructor(
    private logger: Logger,
    private http: HttpClient,
    private serviceConfig: ServiceConfig,
    public storage: LocalStorageService
  ) { }

  // Http Headers
  httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  get(endPoint?: string, queryParams?: any, pathVar?: any, isMAD?: boolean, isDownloadCSV?: boolean): Observable<any> {
    this.httpOptions.params = new HttpParams();
    this.serviceTypeList = isMAD == true ? this.serviceConfig.MADServices : this.serviceConfig.services;
    if (pathVar === undefined || pathVar == null) {
      this.serviceUrl = this.serviceTypeList[endPoint].url;
    } else {
      this.serviceUrl = this.serviceTypeList[endPoint].url + pathVar;
    }
    if (this.serviceTypeList[endPoint].autherization) {
      if(isMAD){
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', localStorage.getItem('MADAccessTokenPrefix') + ' ' + localStorage.getItem('MADAccessToken'));
      }else{
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + localStorage.getItem('accessToken'));
        this.httpOptions.headers = this.httpOptions.headers.set('Role', this.storage.getData('userRole').id.toString());
      }
    } else {
      this.httpOptions.headers = this.httpOptions.headers.set('Authorization', ' ');
      this.httpOptions.headers.delete('Authorization', ' ');
    }
    if (queryParams) {
      for (const key of Object.keys(queryParams)) {
        this.httpOptions.params = this.httpOptions.params.set(key, queryParams[key]);
      }
    }
    if(isDownloadCSV){
      this.httpOptions['responseType'] = 'text';
    }else{
      delete this.httpOptions['responseType']
    }
    console.log('params', this.httpOptions.params);
    return this.http.get(this.serviceUrl, this.httpOptions);
  }
  post(endPoint?: string, urlParams ?: string | number | null, body?: any, isMAD?: boolean): Observable<any> {
    this.serviceTypeList = isMAD == true ? this.serviceConfig.MADServices : this.serviceConfig.services;
    this.serviceUrl = this.serviceTypeList[endPoint].url;
    if(urlParams){
      this.serviceUrl += urlParams + '/';
    }
    this.httpOptions.params = new HttpParams();
    if (this.serviceTypeList[endPoint].autherization) {
      if(isMAD){
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', localStorage.getItem('MADAccessTokenPrefix') + ' ' + localStorage.getItem('MADAccessToken'));
      }else{
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + localStorage.getItem('accessToken'));
        this.httpOptions.headers = this.httpOptions.headers.set('Role', this.storage.getData('userRole').id.toString());
      }
    } else {
      this.httpOptions.headers = this.httpOptions.headers.set('Authorization', ' ');
      this.httpOptions.headers.delete('Authorization', ' ');
    }
    return this.http.post(this.serviceUrl, body, this.httpOptions);
  }

  put(endPoint?: string, urlParams ?: string | number, body?: any, isMAD?: boolean): Observable<any> {
    this.serviceTypeList = isMAD == true ? this.serviceConfig.MADServices : this.serviceConfig.services;
    this.serviceUrl = this.serviceTypeList[endPoint].url;
    if(urlParams){
      this.serviceUrl += urlParams + '/';
    }
    this.httpOptions.params = new HttpParams();
    if (this.serviceTypeList[endPoint].autherization) {
      if(isMAD){
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', localStorage.getItem('MADAccessTokenPrefix') + ' ' + localStorage.getItem('MADAccessToken'));
      }else{
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + localStorage.getItem('accessToken'));
        this.httpOptions.headers = this.httpOptions.headers.set('Role', this.storage.getData('userRole').id.toString());
      }
    } else {
      this.httpOptions.headers = this.httpOptions.headers.set('Authorization', ' ');
      this.httpOptions.headers.delete('Authorization', ' ');
    }
    return this.http.put(this.serviceUrl, body, this.httpOptions);
  }

  delete(endPoint?: string, urlParams ?: string | number, isMAD?: boolean): Observable<any> {
    this.serviceTypeList = isMAD == true ? this.serviceConfig.MADServices : this.serviceConfig.services;
    this.serviceUrl = this.serviceTypeList[endPoint].url;
    if(urlParams){
      this.serviceUrl += urlParams + '/';
    }
    this.httpOptions.params = new HttpParams();
    if (this.serviceTypeList[endPoint].autherization) {
      if(isMAD){
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', localStorage.getItem('MADAccessTokenPrefix') + ' ' + localStorage.getItem('MADAccessToken'));
      }else{
        this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + localStorage.getItem('accessToken'));
        this.httpOptions.headers = this.httpOptions.headers.set('Role', this.storage.getData('userRole').id.toString());
      }
    } else {
      this.httpOptions.headers.delete('Authorization');
    }
    return this.http.delete(this.serviceUrl, this.httpOptions);
  }
}
